var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row mt-3" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "primary", size: "sm" },
              on: { click: _vm.voltar }
            },
            [_c("i", { staticClass: "fas fa-arrow-left" }), _vm._v(" Voltar")]
          ),
          _vm._v(" "),
          _vm.perfil === "adm"
            ? _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "success", size: "sm" },
                  on: { click: _vm.adicionarGrupo }
                },
                [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Adicionar")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c("b-table", {
                attrs: {
                  hover: "",
                  items: _vm.faixas,
                  busy: _vm.isLoading,
                  fields: _vm.header,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                  "empty-text": "Nenhuma faixa de desconto encontrada ...",
                  stacked: "md",
                  "show-empty": "",
                  small: "",
                  striped: ""
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDesc = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Carregando ...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(id)",
                    fn: function(row) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: { size: "sm", variant: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.editar(row.item)
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-edit" })]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n        Grupo de Desconto " +
                      _vm._s(
                        _vm.descontos.length > 0 &&
                          _vm.descontos[0].grupo_desconto
                          ? "- " + _vm.descontos[0].grupo_desconto
                          : null
                      ) +
                      "\n      "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "primary",
                        disabled: _vm.loading || _vm.perfil !== "adm"
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveDesconto()
                        }
                      }
                    },
                    [
                      _vm.loading
                        ? _c(
                            "span",
                            [
                              _c("b-spinner", {
                                attrs: { small: "", type: "grow" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v("\n        Salvar\n      ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalDesconto = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalDesconto,
            callback: function($$v) {
              _vm.modalDesconto = $$v
            },
            expression: "modalDesconto"
          }
        },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.show, rounded: "sm" } },
            [
              _c(
                "b-card",
                [
                  _vm.novaFaixa == true
                    ? _c(
                        "b-row",
                        { staticClass: "mb-3", attrs: { "align-v": "end" } },
                        [
                          _c("b-col", { staticClass: "col-md-2" }, [
                            _c("label", { attrs: { for: "grupoDesc" } }, [
                              _vm._v("Grupo de Desconto")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "col-md-2" },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: "SS",
                                    expression: "'SS'"
                                  }
                                ],
                                attrs: {
                                  autofocus: "",
                                  size: "sm",
                                  id: "grupoDesc",
                                  placeholder: "Z"
                                },
                                model: {
                                  value: _vm.grupoDesconto,
                                  callback: function($$v) {
                                    _vm.grupoDesconto = $$v
                                  },
                                  expression: "grupoDesconto"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mb-3 ml-3" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-left",
                          attrs: {
                            disabled: _vm.perfil !== "adm",
                            variant: "primary",
                            title: "Adicionar",
                            size: "sm"
                          },
                          on: { click: _vm.addDesconto }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v("Adicionar")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.descontos, function(desconto, index) {
                    return _c(
                      "b-row",
                      {
                        key: index,
                        staticClass: "mb-3",
                        attrs: { "align-v": "end" }
                      },
                      [
                        _c(
                          "b-col",
                          [
                            _c("label", { attrs: { for: "min " } }, [
                              _vm._v("Mínimo(R$)")
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: [
                                    "#,##",
                                    "##,##",
                                    "###,##",
                                    "####,##",
                                    "#####,##",
                                    "######,##",
                                    "#######,##",
                                    "########,##",
                                    "#########,##",
                                    "##########,##"
                                  ],
                                  expression:
                                    "['#,##','##,##', '###,##','####,##','#####,##','######,##','#######,##','########,##','#########,##' ,'##########,##']"
                                }
                              ],
                              attrs: {
                                placeholder: "R$",
                                disabled: _vm.perfil !== "adm",
                                id: "min",
                                size: "sm"
                              },
                              model: {
                                value: desconto.quantidade_minima,
                                callback: function($$v) {
                                  _vm.$set(desconto, "quantidade_minima", $$v)
                                },
                                expression: "desconto.quantidade_minima"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("label", { attrs: { for: "max " } }, [
                              _vm._v("Máximo(R$)")
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: [
                                    "#,##",
                                    "##,##",
                                    "###,##",
                                    "####,##",
                                    "#####,##",
                                    "######,##",
                                    "#######,##",
                                    "########,##",
                                    "#########,##",
                                    "##########,##"
                                  ],
                                  expression:
                                    "['#,##','##,##', '###,##','####,##','#####,##','######,##','#######,##','########,##','#########,##' ,'##########,##']"
                                }
                              ],
                              attrs: {
                                placeholder: "R$",
                                disabled: _vm.perfil !== "adm",
                                id: "max",
                                size: "sm"
                              },
                              model: {
                                value: desconto.quantidade_maxima,
                                callback: function($$v) {
                                  _vm.$set(desconto, "quantidade_maxima", $$v)
                                },
                                expression: "desconto.quantidade_maxima"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c("label", { attrs: { for: "val" } }, [
                              _vm._v("Desconto(%)")
                            ]),
                            _vm._v(" "),
                            _c("b-form-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["#,##", "##,##"],
                                  expression: "['#,##','##,##']"
                                }
                              ],
                              attrs: {
                                placeholder: "%",
                                disabled: _vm.perfil !== "adm",
                                id: "val",
                                size: "sm"
                              },
                              model: {
                                value: desconto.valor,
                                callback: function($$v) {
                                  _vm.$set(desconto, "valor", $$v)
                                },
                                expression: "desconto.valor"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "col-md-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  disabled: _vm.perfil !== "adm",
                                  variant: "danger",
                                  size: "sm",
                                  title: "Remover"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeDesconto(desconto, index)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-trash-alt" })]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h1", [_vm._v("Grupo de Descontos Varejo")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e29ecfd0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e29ecfd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/descontos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e29ecfd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/varejo/produtos/descontos.vue
// module chunks = 2